import { Ng2StateDeclaration, UIRouterModule } from '@uirouter/angular';
import { Component } from '@angular/core';
import { SpellingDashboardComponent } from '@client/app/pages/qa/spellcheck/dashboard/spelling-dashboard.component';
import { UiRouterUtil } from '@client/app/blocks/router/ui-router-util';
import {
    SpellingPagesWithErrorComponent,
} from '@client/app/pages/qa/spellcheck/pages-with-error/spelling-pages-with-error.component';
import { SpellingErrorsIndexComponent } from '@client/app/pages/qa/spellcheck/errors/spelling-errors-index.component';
import {
    SpellingDictionaryIndexComponent,
} from '@client/app/pages/qa/spellcheck/dictionary/spelling-dictionary-index.component';
import {
    IgnoredMisspellingsComponent,
} from '@client/app/pages/qa/spellcheck/ignoredMisspellings/ignored-misspellings.component';

@Component({
    selector: 'base-qa-spell-check',
    template: `<ui-view name="content"></ui-view>`,
    standalone: true,
    imports: [UIRouterModule],
})
class BaseQASpellCheckComponent {}

export const QA_SPELL_CHECK_STATES: Ng2StateDeclaration[] = [
    {
        name: 'base.customer.domain.qa.spellcheck',
        url: '/spellcheck',
        abstract: true,
        views: {
            'content@base.customer.domain.qa': {
                component: BaseQASpellCheckComponent,
            },
        },
        redirectTo: 'base.customer.domain.qa.spellcheck.dashboard',
        // No shellPath here: abstract parents are not navigation targets.
        // The prefix is owned by the dashboard leaf below (as a shellAlias).
        data: {
            sidebar: 'quality',
        },
    },
    {
        name: 'base.customer.domain.qa.spellcheck.dashboard',
        url: '/dashboard/',
        views: {
            'content@base.customer.domain.qa.spellcheck': {
                component: SpellingDashboardComponent,
            },
        },
        data: {
            title: 'Acquia Web Governance - Spellcheck Summary',
            /** Shell-facing path for CC breadcrumb/menu sync (see event-bus-bridge.init.ts) */
            shellPath: '/domains/:domainId/quality/spellcheck/dashboard',
            // Incoming alias: breadcrumb clicks on 'Spellcheck' use the group prefix.
            shellAliases: ['/domains/:domainId/quality/spellcheck'],
        },
    },
    {
        name: 'base.customer.domain.qa.spellcheck.pages',
        url: '/pages',
        views: {
            'content@base.customer.domain.qa.spellcheck': {
                component: SpellingPagesWithErrorComponent,
            },
        },
        data: { title: 'Acquia Web Governance - Pages With Misspellings', shellPath: '/domains/:domainId/quality/spellcheck/pages' },
    },
    {
        name: 'base.customer.domain.qa.spellcheck.confirmed',
        url: '/confirmed',
        views: {
            'content@base.customer.domain.qa.spellcheck': {
                component: SpellingErrorsIndexComponent,
            },
        },
        resolve: UiRouterUtil.componentBindings({
            pageDetailTarget: 'misspellings',
            type: 'confirmed',
        }),
        data: { title: 'Acquia Web Governance - Misspellings', shellPath: '/domains/:domainId/quality/spellcheck/confirmed' },
    },
    {
        name: 'base.customer.domain.qa.spellcheck.potential',
        url: '/potential',
        views: {
            'content@base.customer.domain.qa.spellcheck': {
                component: SpellingErrorsIndexComponent,
            },
        },
        resolve: UiRouterUtil.componentBindings({
            pageDetailTarget: 'potential',
            type: 'potential',
            headline: 'Potential misspellings',
        }),
        data: { title: 'Acquia Web Governance - Potential Misspellings', shellPath: '/domains/:domainId/quality/spellcheck/potential' },
    },
    {
        name: 'base.customer.domain.qa.spellcheck.dictionary',
        url: '/dictionary',
        views: {
            'content@base.customer.domain.qa.spellcheck': {
                component: SpellingDictionaryIndexComponent,
            },
        },
        data: { title: 'Acquia Web Governance - Account Dictionary', shellPath: '/domains/:domainId/quality/spellcheck/dictionary' },
    },
    {
        name: 'base.customer.domain.qa.spellcheck.ignored-misspellings',
        url: '/ignored-misspellings',
        views: {
            'content@base.customer.domain.qa.spellcheck': {
                component: IgnoredMisspellingsComponent,
            },
        },
        data: { title: 'Acquia Web Governance - Ignored Misspellings', shellPath: '/domains/:domainId/quality/spellcheck/ignored-misspellings' },
    },
];
